/** All 15-minute-increment time-of-day slots from 00:00 to 23:45, as "HH:mm" strings. */
export const TIME_SLOTS: string[] = Array.from({ length: 96 }, (_, i) => {
  const h = Math.floor(i / 4).toString().padStart(2, "0");
  const m = ((i % 4) * 15).toString().padStart(2, "0");
  return `${h}:${m}`;
});

/**
 * TIME_SLOTS filtered to exclude times already past, when `dateStr` is today.
 * Use for same-day scheduling (interviews, availability) so users can't pick a past slot.
 */
export function futureTimeSlots(dateStr: string, todayStr: string): string[] {
  if (dateStr !== todayStr) return TIME_SLOTS;
  const nowMins = new Date().getHours() * 60 + new Date().getMinutes();
  return TIME_SLOTS.filter(t => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m > nowMins;
  });
}
